// 아이디어 내기 (사고유창력) — 주어진 주제로 제한 시간 안에 서로 다른 생각을 최대한 많이 적는다.
// 채점은 개수(같은 말 반복은 하나로 센다). 질은 따지지 않는다 — 유창성은 '많이, 빨리'가 측정 대상이다.
// 레벨이 오르면 한 주제의 목표 개수가 늘어난다 (레벨 1 = 4개, 레벨 10 = 13개, 주제당 90초).
import { makeRng, shuffle } from './rng';

export const FLUENCY_PROMPTS: [string, string][] = [
  ['쓰임새', '벽돌로 할 수 있는 일을 가능한 한 많이'],
  ['쓰임새', '종이컵의 쓰임새를 가능한 한 많이 (컵 말고)'],
  ['쓰임새', '신문지로 할 수 있는 일을 가능한 한 많이'],
  ['쓰임새', '빈 페트병으로 만들 수 있는 것'],
  ['쓰임새', '클립 하나로 할 수 있는 일'],
  ['쓰임새', '고무줄의 쓰임새'],
  ['쓰임새', '헌 양말로 할 수 있는 일'],
  ['쓰임새', '우산으로 비 막기 말고 할 수 있는 일'],
  ['쓰임새', '숟가락으로 먹기 말고 할 수 있는 일'],
  ['쓰임새', '버려진 타이어를 쓸 곳'],
  ['결과', '모든 사람이 하루 4시간만 자도 괜찮아진다면 생길 일'],
  ['결과', '인터넷이 하루 동안 완전히 끊긴다면 생길 일'],
  ['결과', '사람이 하늘을 날 수 있다면 달라질 것'],
  ['결과', '물가가 갑자기 절반으로 떨어진다면 생길 일'],
  ['결과', '모든 가게가 밤 9시에 문을 닫아야 한다면 생길 일'],
  ['결과', '현금이 완전히 사라진다면 생길 일'],
  ['결과', '1년 내내 비가 온다면 달라질 것'],
  ['결과', '모든 시험이 없어진다면 생길 일'],
  ['결과', '사람의 수명이 150살이 된다면 생길 일'],
  ['결과', '자동차가 모두 자율 주행이 된다면 없어질 직업과 생길 직업'],
  ['찾기', '동그란 물건을 가능한 한 많이'],
  ['찾기', '빨간색인 것을 가능한 한 많이'],
  ['찾기', '소리가 나는 물건'],
  ['찾기', '바퀴가 달린 것'],
  ['찾기', '물에 뜨는 것'],
  ['찾기', '접을 수 있는 것'],
  ['찾기', '전기 없이 움직이는 것'],
  ['찾기', '한 손에 들 수 있고 따뜻한 것'],
  ['개선', '편의점 매출을 올리는 방법'],
  ['개선', '출근길 지하철을 덜 붐비게 하는 방법'],
  ['개선', '우산을 더 편하게 만드는 방법'],
  ['개선', '공부를 덜 지루하게 하는 방법'],
  ['개선', '치킨집에 손님이 다시 오게 만드는 방법'],
  ['개선', '회의 시간을 줄이는 방법'],
  ['개선', '배달 쓰레기를 줄이는 방법'],
  ['개선', '혼자 사는 사람의 외로움을 줄이는 방법'],
  ['개선', '동네 카페가 대형 프랜차이즈를 이기는 방법'],
  ['이름', '새로 여는 반찬 가게 이름'],
  ['이름', '두뇌 훈련 앱 이름'],
  ['이름', '24시간 무인 빨래방 이름'],
];

export const FLUENCY_SECONDS = 90;
export const fluencyTarget = (level: number) => 3 + Math.min(10, Math.max(1, level));

/** 같은 아이디어로 볼 기준 — 띄어쓰기·문장부호·대소문자 무시 */
export const ideaKey = (s: string) => s.toLowerCase().replace(/[\s.,!?~'"()·-]/g, '');

export function countIdeas(ideas: string[]): number {
  return new Set(ideas.map(ideaKey).filter((k) => k.length > 0)).size;
}

export function makeFluencyRound(seed: number): [string, string][] {
  return shuffle(makeRng(seed), FLUENCY_PROMPTS).slice(0, 2);
}
